/* Halloween Props — Nocturne interactions */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Countdown(s) ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function initCountdowns(root) {
    (root || document).querySelectorAll('[data-hp-countdown]').forEach(function (el) {
      if (el.__hp) return; el.__hp = true;
      var target = new Date(el.getAttribute('data-target')).getTime();
      if (isNaN(target)) return;
      var u = {};
      ['d', 'h', 'm', 's'].forEach(function (k) { u[k] = el.querySelector('[data-u="' + k + '"]'); });
      function tick() {
        var diff = Math.max(0, target - Date.now());
        var d = Math.floor(diff / 864e5), h = Math.floor(diff / 36e5) % 24, m = Math.floor(diff / 6e4) % 60, s = Math.floor(diff / 1e3) % 60;
        if (u.d) u.d.textContent = pad(d);
        if (u.h) u.h.textContent = pad(h);
        if (u.m) u.m.textContent = pad(m);
        if (u.s) u.s.textContent = pad(s);
        var inline = el.querySelector('[data-u="inline"]');
        if (inline) inline.textContent = d + 'd ' + pad(h) + 'h ' + pad(m) + 'm';
      }
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---------- Embers ---------- */
  function initEmbers(root) {
    (root || document).querySelectorAll('[data-embers]').forEach(function (c) {
      if (c.__hp || reduce) return; c.__hp = true;
      var ctx = c.getContext('2d'), w, h, dpr = Math.min(window.devicePixelRatio || 1, 2), parts = [];
      function size() { w = c.clientWidth; h = c.clientHeight; c.width = w * dpr; c.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
      size(); window.addEventListener('resize', size);
      var N = Math.round(Math.min(70, w / 22));
      function spawn(p, init) {
        p.x = Math.random() * w; p.y = init ? Math.random() * h : h + 10;
        p.r = Math.random() * 1.8 + 0.4; p.vy = -(Math.random() * 0.5 + 0.18); p.vx = (Math.random() - 0.5) * 0.25;
        p.life = Math.random() * 0.6 + 0.4; p.t = Math.random() * 6.28; return p;
      }
      for (var i = 0; i < N; i++) parts.push(spawn({}, true));
      var visible = true;
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(c);
      (function loop() {
        requestAnimationFrame(loop);
        if (!visible) return;
        ctx.clearRect(0, 0, w, h);
        for (var i = 0; i < parts.length; i++) {
          var p = parts[i]; p.t += 0.02; p.x += p.vx + Math.sin(p.t) * 0.25; p.y += p.vy;
          if (p.y < -10) spawn(p);
          var a = Math.max(0, Math.min(1, (p.y / h))) * p.life;
          var g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 4);
          g.addColorStop(0, 'rgba(255,170,90,' + a + ')'); g.addColorStop(0.4, 'rgba(255,90,31,' + a * 0.5 + ')'); g.addColorStop(1, 'rgba(255,90,31,0)');
          ctx.fillStyle = g; ctx.beginPath(); ctx.arc(p.x, p.y, p.r * 4, 0, 6.283); ctx.fill();
        }
      })();
    });
  }

  /* ---------- Parallax ---------- */
  function initParallax(root) {
    if (reduce) return;
    (root || document).querySelectorAll('[data-hp-hero]').forEach(function (hero) {
      if (hero.__hp) return; hero.__hp = true;
      var layers = hero.querySelectorAll('[data-depth]'), tx = 0, ty = 0, cx = 0, cy = 0, sy = 0;
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect(); tx = (e.clientX - r.left) / r.width - 0.5; ty = (e.clientY - r.top) / r.height - 0.5;
      });
      window.addEventListener('scroll', function () { sy = window.scrollY; }, { passive: true });
      (function loop() {
        requestAnimationFrame(loop);
        cx += (tx - cx) * 0.06; cy += (ty - cy) * 0.06;
        layers.forEach(function (l) {
          var d = parseFloat(l.getAttribute('data-depth')) || 0;
          l.style.transform = 'translate3d(' + (-cx * d * 1200).toFixed(2) + 'px,' + (-cy * d * 600 + sy * d * 4).toFixed(2) + 'px,0)';
        });
      })();
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.hp-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e, i) { e.style.transitionDelay = (e.dataset.delay || 0) + 'ms'; io.observe(e); });
  }

  /* ---------- Tilt on mosaic tiles ---------- */
  function initTilt(root) {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    (root || document).querySelectorAll('[data-hp-tilt]').forEach(function (el) {
      if (el.__hp) return; el.__hp = true;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        el.style.setProperty('--mx', (x * 100) + '%'); el.style.setProperty('--my', (y * 100) + '%');
        el.style.transform = 'perspective(1000px) rotateX(' + ((0.5 - y) * 5).toFixed(2) + 'deg) rotateY(' + ((x - 0.5) * 6).toFixed(2) + 'deg)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  function initAll(root) { initCountdowns(root); initEmbers(root); initParallax(root); initReveal(root); initTilt(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
